module.exports = __webpack_public_path__ + "static/media/avetar.ad1059e6.jpg";